$(document).ready(function(){
  $('.multimedia .icon-grid').click(function(){
    var index = $(this).data('index');

    $('.multimedia .media-with-text__media img').removeClass('active');
    $('.multimedia .icon-grid').removeClass('active');
    $('.multimedia .icon-grid[data-index="' + index + '"]').addClass('active');
    $(this).parent().parent().parent().siblings().find('.media-' + index).addClass('active');
    
  });

  $('.media-main--atc, .media-thumbnail--title').click(function(){
    window.location.href = $(this).data('url');
  })

  $(document).on('click','.media-thumbnail--link',(e) => {
    location.href = e.target.dataset.url
  });

  var $status = $('.media-thumbnail--number');
  var $thumbnail = $('.media-thumbnail--slider');
  $thumbnail.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    if(!slick.$dots){
    	return;
    }
    
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + (slick.$dots[0].children.length));
  });


  $thumbnail.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: false,
    arrows: true,
    dots: true,
    prevArrow: $('.slide-prev'),
    nextArrow: $('.slide-next')
  });
});

